<template>
  <div class="serviec-rule">
    <el-dialog :title="title" :visible.sync="value" :before-close="handleClose"  :close-on-click-modal="false">
      <div class="select-date"  v-if="ruleList.length"> 
         <p v-for="(item,index) in ruleList" :key="index">{{index + 1}}、{{item}} </p> 
      </div>
      <div class="select-date"  v-else> 
         <p>暂无规则</p>
      </div> 
    </el-dialog>
  </div>
</template>

<script>
import * as requestApi from '@/utils/appointment.url';
export default {
  name: "serviceRule",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // itemInfo:{
    //   type: Object,
    //   default: {},
    // }, 
  }, 
  data() {
    return {
      title:"预约服务规则", 
      ruleList:[],//规则列表
      bsSeq:this.$route.query.bsSeq,
    };
  },

  methods: { 
    // 关闭弹窗回传状态
    handleClose() {  
      this.$emit("input", false); 
    }, 
    serviceRule(val){
      requestApi.serviceRule({
        bsSeq: val,
      },'get').then(res => { 
        if(Number(res.status) === 200){
          this.ruleList = res.data;
        }else{
          this.$message.error(res.desc);
        }
      }).catch(err => {
        console.log(err);
      });
    }
  },
  mounted() {   
    this.serviceRule(this.bsSeq);
  }
};
</script>

<style lang="scss">
/*新增弹窗*/
.serviec-rule { 
  .el-dialog {
    width: 422px;
   
    color: #333333;  
    .el-dialog__header { 
      padding: 10px 20px;
      .el-dialog__title {  
        padding: 0;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC; 
      } 
      .el-dialog__headerbtn {
        &:focus {
          outline: 1px solid $main-color;
        }
      }
    }
    .el-dialog__body{
       max-height: 300px;
       overflow: auto;
       font-size: 16px;
       line-height: 22px; 
       color: #545454;
       .select-date{
         overflow: auto;
       }
    }
  }
  .el-table th.is-leaf{
      background: #F9F9F9;
  }
}
</style> 